import axios from "infra/http";
import { useQuery } from "react-query";
import { TipoAutorizacaoPortariaParametroItem } from "../typings/index";

function useParametrosPortaria() {
  return useQuery(`/v1/portaria/tipo-autorizacao-parametros`, async () => {
    const { data } = await axios.get<TipoAutorizacaoPortariaParametroItem[]>(
      `/v1/portaria/tipo-autorizacao-parametros`
    );

    return data;
  });
}

export default useParametrosPortaria;
